import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faHandshakeSimple, faGraduationCap, faGavel, faPowerOff, faBinoculars, faPeopleGroup, faHourglass } from '@fortawesome/free-solid-svg-icons';

library.add(faHandshakeSimple);
library.add(faGraduationCap);
library.add(faGavel);
library.add(faPowerOff);
library.add(faBinoculars);
library.add(faPeopleGroup);
library.add(faHourglass);
